import { render, staticRenderFns } from "./NewEvent.vue?vue&type=template&id=0f60d156&scoped=true"
import script from "./NewEvent.vue?vue&type=script&lang=js"
export * from "./NewEvent.vue?vue&type=script&lang=js"
import style0 from "./NewEvent.vue?vue&type=style&index=0&id=0f60d156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60d156",
  null
  
)

export default component.exports